import React, { useState, useEffect } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import {
  fileUploadAfterSignURL,
  generateMultipleSignUrl,
  updateStudentImage,
} from "../../actions/emActions";
import { Spinner } from "reactstrap";

function ImageCropComponent({ studentImage, studentId, handleModalShow }) {
  const [src, setSrc] = useState(null);
  const [crop, setCrop] = useState({
    aspect: 1,
    x: 0,
    y: 0,
    width: 300,
    height: 300,
    borderRadius: 50,
  });
  const [image, setImage] = useState(null);
  const [output, setOutput] = useState(null);
  const [croppedFile, setcroppedFile] = useState(null);

  const selectImage = (file) => {
    setSrc(URL.createObjectURL(file));
  };

  const onImageLoaded = (image) => {
    setImage(image);
  };

  const onCropChange = (newCrop) => {
    setCrop(newCrop);
  };

  const createCropFile = async () => {
    const croppedBlob = await cropImageNow();
    if (croppedBlob) {
      const croppedFile = new File([croppedBlob], "cropped-image.jpeg", {
        type: "image/jpeg",
      });
      console.log("croppedFile", croppedFile);
      const imageUrl = URL.createObjectURL(croppedFile);
      setcroppedFile(imageUrl);
      setPrevImage(imageUrl);
      setuploadedImage(croppedFile);
      // Now you can upload `croppedFile` to the server
      // Example: uploadFile(croppedFile);
    } else {
      console.error("Failed to crop image");
    }
  };

  const cropImageNow = () => {
    if (image && crop.width && crop.height) {
      const canvas = document.createElement("canvas");
      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;
      canvas.width = crop.width;
      canvas.height = crop.height;
      const ctx = canvas.getContext("2d");

      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      );

      // Converting to base64
      const base64Image = canvas.toDataURL("image/jpeg");
      setOutput(base64Image);

      // Convert canvas to Blob
      return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
          if (!blob) {
            reject(new Error("Failed to create blob"));
            return;
          }
          resolve(blob);
        }, "image/jpeg"); // Specify the desired MIME type here (e.g., image/jpeg)
      });
    }
  };

  const [prevImage, setPrevImage] = useState(null);
  const [uploadedImage, setuploadedImage] = useState(null);
  const [uploadLoading, setuploadLoading] = useState(false);

  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    if (selectedImage) {
      //   const reader = new FileReader();
      //   reader.onloadend = () => {
      //     setPrevImage(reader.result);
      //   };
      //   reader.readAsDataURL(selectedImage);
      setuploadedImage(selectedImage);
      setSrc(URL.createObjectURL(selectedImage));
      setPrevImage(null);
    }
  };

  console.log("Images", image);
  console.log("Images", uploadedImage);
  const uploadFeedFunc = () => {
    setuploadLoading(true);
    const items = [
      {
        filename: uploadedImage?.name,
        fileUserType: "student",
        contentType: uploadedImage?.type,
        label: "profileImages",
        userId: studentId.toString(),
      },
    ];

    let feedData = {};

    generateMultipleSignUrl(items)
      .then((res) => {
        debugger;
        if (res?.status === 201) {
          const uploadPromises = res?.data?.map((item, index) => {
            return fileUploadAfterSignURL(item?.signurl, uploadedImage);
          });

          feedData = {
            image: res?.data?.[0]?.filename,
            userId: studentId,
          };

          // Wait for all uploads to complete
          return Promise.all(uploadPromises);
        }
      })
      .then((uploadResults) => {
        // Check if all uploads were successful
        const allUploadsSuccessful = uploadResults.every(
          (result) => result.status === 200
        );
        if (allUploadsSuccessful) {
          updateStudentImage(feedData).then((res) => {
            if (res?.status === 201) {
              window.location.reload();
              setuploadLoading(false);
            } else {
              window.alert(res);
              console.log("Error", res);
            }
          });
        } else {
          // Handle the case where not all files were uploaded successfully
          console.log("Some files failed to upload.");
        }
      })
      .catch((error) => {
        // Handle any errors that occurred during the process
        console.error("Error during file upload:", error);
      })
      .finally(() => {
        setuploadLoading(false);
      });
  };

  useEffect(() => {
    setPrevImage(studentImage);
  }, []);

  const removeImage = () => {
    setImage(null);
  };

  return (
    <div className="">
      <div className="mb-2">
        <label className="font-weight-bold mb-0" style={{ fontSize: 20 }}>
          Update Your Profile Picture
        </label>
        <br />
        {prevImage ? (
          <span style={{ fontSize: 12 }}>
            (Click on the avatar to upload a new picture)
          </span>
        ) : (
          <span style={{ fontSize: 12 }}>
            (Adjust the Crop area for your profile picture)
          </span>
        )}
      </div>

      {prevImage && (
        <label htmlFor="fileInput">
          <input
            type="file"
            accept="image/*"
            id="fileInput"
            style={{ display: "none" }}
            onChange={handleImageChange}
          />
          <div
            className="rounded-circle text-center bg-light"
            style={{
              cursor: "pointer",
              border: "2px solid #ddd",
              width: 200,
              height: 200,
              paddingTop: 7,
            }}
          >
            <img
              src={prevImage}
              alt="Selected"
              style={{
                width: 180,
                height: 180,
                borderRadius: "50%",
              }}
            />
          </div>
        </label>
      )}
      {prevImage && (
        <div className="mt-3">
          <button
            className="btn btn-success btn-sm"
            onClick={uploadFeedFunc}
            disabled={uploadLoading}
          >
            {uploadLoading ? <Spinner size="sm" /> : "Update Image"}
          </button>
        </div>
      )}
      {!prevImage && (
        <center>
          <div>
            {src && (
              <div>
                <ReactCrop
                  src={src}
                  crop={crop}
                  onChange={onCropChange}
                  onImageLoaded={onImageLoaded}
                  keepSelection={true}
                  circularCrop={true}
                />
                <br />
                <button
                  className="mb-5 mt-2 btn btn-success btn-sm"
                  onClick={createCropFile}
                >
                  Crop this image
                </button>
                <br />
                <br />
              </div>
            )}
          </div>
          {/* <div>{output && <img src={output} alt="Cropped Image" />}</div> */}
        </center>
      )}
    </div>
  );
}

export default ImageCropComponent;
